import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const heroH1 = document.querySelector('#home-hero h1');
if (heroH1) {
  gsap.to(heroH1, {
    y: '100%', 
    opacity: 0,
    ease: 'power1.inOut',
    scrollTrigger: {
      trigger: 'body', 
      start: 'top top', 
      end: '33% top', 
      scrub: true, 

    }
  });
} 

const newsletter = document.querySelector('#global-newsletter');
const socials = document.querySelector('#global-socials');

if (newsletter) {
  gsap.to(newsletter, {
    x: '-200%', 
    ease: 'power1.inOut',
    scrollTrigger: {
      trigger: 'body', 
      start: 'top top', 
      end: '2.5% top', 
      scrub: true, 

    }
  });
} 

if (socials) {
  gsap.to(socials, {
    x: '200%', 
    ease: 'power1.inOut',
    scrollTrigger: {
      trigger: 'body', 
      start: 'top top',
      end: '2.5% top', 
      scrub: true,

    }
  });
} 


const footerLogo = document.querySelector('#footer-logo');

const paths = footerLogo.querySelectorAll('path');



const tl = gsap.timeline({
  scrollTrigger: {
    trigger: '#global-footer',
    start: 'top 90%', 
    end: 'bottom bottom', 
    scrub: .5, 
  }
});

gsap.set(paths, { 
  y: '100%',
});

paths.forEach((path, index) => {

  const staggerOffset = index * 0.5; 
  
  tl.to(path, {
    y: 0,     
    duration: 1, 
  }, staggerOffset); 
});


const logoIcon = document.querySelector('.soluna-logo-icon');

if (logoIcon) {
  gsap.to(logoIcon, {
    rotation: 180, 
    ease: "none",
    scrollTrigger: {
      trigger: "body", 
      start: "top top", 
      end: "bottom bottom", 
      scrub: .75, 
    }
  });
}

const icon = document.querySelector('#about-intro-icon');

 ScrollTrigger.create({
  trigger: document.body,
  start: 'top top',
  end: 'bottom bottom',
  pin: icon,
  pinSpacing: false,
  invalidateOnRefresh: true,
});

document.addEventListener("DOMContentLoaded", function() {
  const toggleButtons = document.querySelectorAll('.mobile-menu-toggle');

  const mobileMenu = document.getElementById('mobile-menu');
  
  toggleButtons.forEach(button => {
    button.addEventListener('click', function() {
      mobileMenu.classList.toggle('-translate-y-full');
    });
  });
  
  mobileMenu.addEventListener('focusout', function(e) {
    if (!mobileMenu.contains(e.relatedTarget) && !mobileMenu.classList.contains('-translate-y-full')) {
      setTimeout(() => {
        if (!mobileMenu.contains(document.activeElement)) {
          mobileMenu.classList.add('-translate-y-full');
        }
      }, 0);
    }
  });
  
  const mobileMenuItems = mobileMenu.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
  mobileMenuItems.forEach(item => {
    item.addEventListener('focus', function() {
      if (mobileMenu.classList.contains('-translate-y-full')) {
        mobileMenu.classList.remove('-translate-y-full');
      }
    });
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !mobileMenu.classList.contains('-translate-y-full')) {
      mobileMenu.classList.add('-translate-y-full');
      toggleButtons[0].focus();
    }
  });
  
  document.body.classList.add("loaded");
  var globalHeader = document.querySelector('#global-header');
  var menuItems = globalHeader.querySelectorAll('.menu-item-has-children');
  var currentOpen = null;
  var navContainer = globalHeader.querySelector('.main-navigation'); 
  
  menuItems.forEach(function(item) {
    item.addEventListener('mouseenter', function() {
      if (currentOpen && currentOpen !== item) {
        currentOpen.classList.remove('open');
      }
      item.classList.add('open');
      currentOpen = item;
    });
    var directAnchor = item.querySelector(':scope > a');
   if (directAnchor) {
      directAnchor.addEventListener('click', function(e) {
        if (currentOpen == item) {
          currentOpen.classList.remove('open');
          currentOpen = null;
        } else{
          item.classList.add('open');
          currentOpen = item;
        }
        e.stopPropagation();
        e.preventDefault();
      });
  }
    
    item.addEventListener('mouseleave', function() {
      if (!item.contains(document.activeElement)) {
        item.classList.remove('open');
        if (currentOpen === item) {
          currentOpen = null;
        }
      }
    });
    
    var anchor = item.querySelector('a');
    if (anchor) {
      anchor.addEventListener('focus', function() {
        if (currentOpen && currentOpen !== item) {
          currentOpen.classList.remove('open');
        }
        item.classList.add('open');
        currentOpen = item;
      });
      
      anchor.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
          e.preventDefault();
          item.classList.add('open');
          currentOpen = item;
          
          var subMenu = item.querySelector('.sub-menu');
          if (subMenu && subMenu.querySelector('a')) {
            subMenu.querySelector('a').focus();
          }
        }
      });
    }
    
    var subMenu = item.querySelector('.sub-menu');
    if (subMenu) {
      var subLinks = subMenu.querySelectorAll('a');
      
      subLinks.forEach(function(link, index) {
        link.addEventListener('keydown', function(e) {
          if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (index > 0) {
              subLinks[index - 1].focus();
            } else {
              var parentAnchor = item.querySelector(':scope > a');
              if (parentAnchor) parentAnchor.focus();
            }
          } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (index < subLinks.length - 1) {
              subLinks[index + 1].focus();
            }
          } else if (e.key === 'Escape') {
            e.preventDefault();
            item.classList.remove('open');
            currentOpen = null;
            var parentAnchor = item.querySelector(':scope > a');
            if (parentAnchor) parentAnchor.focus();
          }
        });
        
        link.addEventListener('blur', function(e) {
          if (!item.contains(e.relatedTarget)) {
            item.classList.remove('open');
            if (currentOpen === item) {
              currentOpen = null;
            }
          }
        });
        
        link.addEventListener('focus', function() {
          if (currentOpen && currentOpen !== item) {
            currentOpen.classList.remove('open');
          }
          item.classList.add('open');
          currentOpen = item;
        });
      });
    }
  });
  
  if (navContainer) {
    navContainer.addEventListener('focusout', function(e) {
      if (!navContainer.contains(e.relatedTarget)) {
        if (currentOpen) {
          currentOpen.classList.remove('open');
          currentOpen = null;
        }
      }
    });
  }
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && currentOpen) {
      currentOpen.classList.remove('open');
      var parentAnchor = currentOpen.querySelector(':scope > a');
      if (parentAnchor) parentAnchor.focus();
      currentOpen = null;
    }
  });
  
  
  const remValue = .5; 
  const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
  const pixelValue = remValue * rootFontSize;
  
  const swiperElements = document.querySelectorAll('.carousel');
  
  if (swiperElements.length > 0) {
    swiperElements.forEach(function(swiperElement) {
      const mySwiper = new Swiper(swiperElement, {
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        speed: 800,
        autoplay: {
          delay: 3000,
        },
        initialSlide:0,
        spaceBetween: pixelValue, 
      });
    });
  }
  
});